// Copyright ©️ 2026 eVolve MEP, LLC

import { OPACITY_MAX, OPACITY_MIN } from 'components/Autodesk/extensions/MarkupModeExtension/constants';

import { NumberInput } from './NumberInput';

/**
 * Props for a paired color + opacity field used in the markup properties panel.
 */
export type ColorFieldProps = {
  colorId: string;
  labelId: string;
  opacityId: string;
  colorLabel: string;
  opacityLabel: string;
  colorDisplayValue: string;
  colorValue?: string;
  opacityValue: string;
};

/** Renders a color picker and matching opacity input side by side. */
export const ColorField = ({
  colorId,
  labelId,
  opacityId,
  colorLabel,
  opacityLabel,
  colorDisplayValue,
  colorValue,
  opacityValue,
}: ColorFieldProps) => (
  <div className="color-and-opacity-group">
    <div className="field-wrapper">
      <div>{colorLabel}</div>
      <label htmlFor={colorId} className="color-input-container">
        <div className="color-input-wrapper">
          <input id={colorId} name={colorId} type="color" defaultValue={colorValue} />
        </div>
        <div id={labelId}>{colorDisplayValue}</div>
      </label>
    </div>
    <div className="field-wrapper">
      <label htmlFor={opacityId}>{opacityLabel}</label>
      <NumberInput
        id={opacityId}
        unitOfMeasure="%"
        min={OPACITY_MIN}
        max={OPACITY_MAX}
        step={1}
        defaultValue={opacityValue}
        className="opacity-input"
      />
    </div>
  </div>
);
